"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveCreateFileFromText = exports.googleDriveCreateFileFromTextResultSchema = exports.googleDriveCreateFileFromTextArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveCreateFileFromTextArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('create-file-from-text', zod_1.z.object({
    name: zod_1.z.string().nullish().describe("The file's name (default to 'Untitled' if not provided)"),
    content: zod_1.z.string().describe("The content's of this file"),
    mimeType: zod_1.z
        .string()
        .describe("The format in which the text is presented. Can be 'text/plain', 'text/markdown', 'text/html', 'application/rtf', or 'text/csv'"),
}));
var googleDriveFileSchema = zod_1.z.object({
    kind: zod_1.z.string().describe('Identifies what kind of resource this is'),
    mimeType: zod_1.z.string().describe('The MIME type of the file'),
    name: zod_1.z.string().describe('The name of the file'),
    id: zod_1.z.string().describe('The id of this file'),
    cdnUrl: zod_1.z
        .string()
        .optional()
        .describe('A direct download CDN based link for the file, best for direct access outside of Google Drive'),
    googleDriveUrl: zod_1.z.string().optional().describe('The Google Drive URL for this file'),
});
exports.googleDriveCreateFileFromTextResultSchema = (0, common_1.PipedreamNodeResultSchema)(googleDriveFileSchema);
exports.googleDriveCreateFileFromText = (0, common_1.createToolMetadata)({
    id: 'googleDriveCreateFileFromText',
    displayName: 'Google Drive Create File From Text',
    displayDescription: 'Create a new file from text in Google Drive. Returns googleDriveUrl and cdnUrl.',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveCreateFileFromTextArgsSchema,
}, exports.googleDriveCreateFileFromTextResultSchema);
